import React from "react";
import { observer } from "mobx-react";
import { EsignatureConfigViewStore } from "../../store";
import { EsignatureConfigViewForm } from "./EsignatureConfigViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type EsignatureConfigViewProps = {
  esignatureConfigViewStore: EsignatureConfigViewStore;
};

export const EsignatureConfigView: React.FC<EsignatureConfigViewProps> =
  observer(({ esignatureConfigViewStore }) => {
    return (
      <div>
        <EsignatureConfigViewForm
          providerOptions={esignatureConfigViewStore.getProviderOptions()}
          provider={esignatureConfigViewStore.providerValue}
          credentials={esignatureConfigViewStore.credentialsValue}
          sandboxMode={esignatureConfigViewStore.sandboxModeValue}
          webhookSecret={esignatureConfigViewStore.webhookSecretValue}
          enabled={esignatureConfigViewStore.enabledValue}
          onPrint={(handlePrint: () => void) =>
            esignatureConfigViewStore.printEsignatureConfig(handlePrint)
          }
          onCancel={() => esignatureConfigViewStore.cancelEsignatureConfig()}
          onEdit={
            esignatureConfigViewStore.isEditEnabled
              ? () => esignatureConfigViewStore.editEsignatureConfig()
              : undefined
          }
        />
        <ErrorDialog
          open={esignatureConfigViewStore.errorDialogOpened}
          title={esignatureConfigViewStore.errorTitle}
          description={esignatureConfigViewStore.errorDescription}
          onClose={() => esignatureConfigViewStore.closeErrorDialog()}
        />
      </div>
    );
  });
